/* ConditionNode — Custom React Flow node for if/else type (two outputs) */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import css from '../../AutomationEditor.module.css';
import NodeIcon from './NodeIcon';

export default memo(function ConditionNode({ data, selected }: NodeProps) {
  const color = (data.color as string) || '#8b5cf6';

  return (
    <div
      className={`${css.customNode}${selected ? ` ${css.selected}` : ''}`}
      style={{ borderColor: color }}
    >
      <div className={css.nodeHeader}>
        <div className={css.nodeIcon} style={{ background: color }}>
          <NodeIcon icon={(data.icon as string) || '◆'} />
        </div>
        <div>
          <div className={css.nodeLabel}>{data.label as string}</div>
          <div className={css.nodeType}>Condition</div>
        </div>
      </div>

      <Handle type="target" position={Position.Top} id="default" />

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
        <span className={css.nodeBadge} style={{ background: '#dcfce7', color: '#166534' }}>
          True
        </span>
        <span className={css.nodeBadge} style={{ background: '#fef2f2', color: '#991b1b' }}>
          False
        </span>
      </div>

      <Handle type="source" position={Position.Bottom} id="true" style={{ left: '30%' }} />
      <Handle type="source" position={Position.Bottom} id="false" style={{ left: '70%' }} />
    </div>
  );
});
